export default __webpack_public_path__ + "static/19-6bd7a5ac71b4b5a3a46fed62ed0b2d71.jpg";